import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'
import type { FeatureFlagsResponse } from '@app/types'

export const fetchFeatureFlags = async (): Promise<FeatureFlagsResponse> => {
  const response = await apiClient.get<FeatureFlagsResponse>(Endpoint.getFeatureFlags, {
    headers: {
      client_name: localStorage.getItem('client-name') ?? '',
    },
  })
  return response.data
}
